import { useRef, useEffect, useState } from 'react';

const genres = [
  {
    name: '貴金属',
    desc: '金・銀・プラチナ製品',
    tag: '高価買取中',
    alt: '貴金属（金・銀・プラチナ）高価買取 — 天神屋 福岡・九州出張買取専門店',
    title: '貴金属買取 | 金・銀・プラチナ製品を高価査定',
    img: 'https://public.readdy.ai/ai/img_res/af44c58729dd3347cc0438bc832e23c0.jpg',
  },
  {
    name: '宝石',
    desc: 'ダイヤ・ルビー・エメラルド',
    tag: '高価買取中',
    alt: '宝石（ダイヤ・ルビー・エメラルド）高価買取 — 天神屋 出張査定',
    title: '宝石買取 | ダイヤモンド・ルビー・エメラルドを高価査定',
    img: 'https://readdy.ai/api/search-image?query=sparkling%20precious%20gemstones%20diamonds%20ruby%20emerald%20sapphire%20on%20dark%20velvet%20background%20elegant%20jewelry%20store%20display%20professional%20photography%20studio%20lighting&width=400&height=500&seq=genre2&orientation=portrait',
  },
  {
    name: 'ブランド品',
    desc: 'バッグ・財布・時計',
    tag: '人気',
    alt: 'ブランド品（バッグ・財布・時計）買取 — ルイヴィトン・シャネル・エルメス・ロレックス',
    title: 'ブランド品買取 | バッグ・財布・時計を高価査定',
    img: 'https://readdy.ai/api/search-image?query=luxury%20designer%20handbags%20wallets%20watches%20Louis%20Vuitton%20Chanel%20Hermes%20Rolex%20on%20dark%20clean%20background%20high%20end%20fashion%20accessories%20professional%20studio%20photography&width=400&height=500&seq=genre3&orientation=portrait',
  },
  {
    name: 'カメラ',
    desc: '一眼・フィルム・レンズ',
    tag: '需要増加',
    alt: 'カメラ（一眼レフ・フィルムカメラ・レンズ）買取 — 天神屋 出張査定',
    title: 'カメラ買取 | 一眼レフ・フィルムカメラ・レンズを高価査定',
    img: 'https://readdy.ai/api/search-image?query=professional%20vintage%20and%20modern%20film%20digital%20cameras%20Canon%20Nikon%20Leica%20lenses%20on%20dark%20background%20elegant%20product%20photography%20warm%20studio%20lighting&width=400&height=500&seq=genre4&orientation=portrait',
  },
  {
    name: 'お酒',
    desc: 'ウイスキー・ワイン・日本酒',
    tag: '高価買取中',
    alt: 'お酒（ウイスキー・ワイン・日本酒）買取 — 天神屋 高価査定',
    title: 'お酒買取 | ウイスキー・ワイン・日本酒を高価査定',
    img: 'https://readdy.ai/api/search-image?query=premium%20whisky%20bourbon%20wine%20champagne%20sake%20bottles%20collection%20dark%20elegant%20background%20warm%20amber%20lighting%20professional%20product%20photography&width=400&height=500&seq=genre5&orientation=portrait',
  },
  {
    name: '金券',
    desc: '商品券・ギフト券・切手',
    tag: '即日対応',
    alt: '金券（商品券・ギフト券・切手）買取 — 天神屋 即日対応',
    title: '金券買取 | 商品券・ギフト券・切手を即日査定',
    img: 'https://readdy.ai/api/search-image?query=gift%20vouchers%20shopping%20gift%20cards%20department%20store%20tickets%20stamps%20neatly%20arranged%20on%20clean%20elegant%20dark%20surface%20minimal%20product%20photography&width=400&height=500&seq=genre6&orientation=portrait',
  },
  {
    name: '骨董品',
    desc: '陶磁器・掛軸・茶道具',
    tag: '査定無料',
    alt: '骨董品（陶磁器・掛軸・茶道具）買取 — 天神屋 無料査定',
    title: '骨董品買取 | 陶磁器・掛軸・茶道具を無料査定',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20antique%20ceramics%20porcelain%20vase%20tea%20ceremony%20tools%20hanging%20scrolls%20on%20dark%20background%20elegant%20museum%20lighting%20warm%20professional%20photography&width=400&height=500&seq=genre7&orientation=portrait',
  },
  {
    name: '家電',
    desc: 'テレビ・調理家電・掃除機',
    tag: '幅広く対応',
    alt: '家電（テレビ・調理家電・掃除機）買取 — 天神屋 出張査定',
    title: '家電買取 | テレビ・調理家電・掃除機を査定',
    img: 'https://readdy.ai/api/search-image?query=modern%20home%20electronics%20appliances%20television%20kitchen%20appliances%20vacuum%20cleaner%20on%20clean%20dark%20background%20professional%20product%20photography%20minimal%20style&width=400&height=500&seq=genre8&orientation=portrait',
  },
  {
    name: '楽器',
    desc: 'ギター・ピアノ・管楽器',
    tag: '高価買取中',
    alt: '楽器（ギター・ピアノ・管楽器）高価買取 — 天神屋 出張査定',
    title: '楽器買取 | ギター・ピアノ・管楽器を高価査定',
    img: 'https://readdy.ai/api/search-image?query=musical%20instruments%20acoustic%20electric%20guitar%20violin%20saxophone%20piano%20on%20dark%20background%20professional%20photography%20studio%20lighting%20elegant%20display&width=400&height=500&seq=genre9&orientation=portrait',
  },
  {
    name: '電動工具',
    desc: 'ドリル・インパクト・丸鋸',
    tag: '需要増加',
    alt: '電動工具（ドリル・インパクトドライバー・丸鋸）買取 — 天神屋',
    title: '電動工具買取 | ドリル・インパクト・丸鋸を査定',
    img: 'https://readdy.ai/api/search-image?query=professional%20power%20tools%20drill%20impact%20driver%20circular%20saw%20set%20Makita%20Hikoki%20neatly%20arranged%20on%20dark%20industrial%20background%20product%20photography&width=400&height=500&seq=genre10&orientation=portrait',
  },
  {
    name: 'ゲーム',
    desc: 'ゲーム機・ソフト・周辺機器',
    tag: '人気',
    alt: 'ゲーム（ゲーム機・ソフト・周辺機器）買取 — 天神屋 出張査定',
    title: 'ゲーム買取 | ゲーム機・ソフト・周辺機器を査定',
    img: 'https://readdy.ai/api/search-image?query=gaming%20consoles%20PlayStation%20Nintendo%20Switch%20Xbox%20controllers%20game%20software%20collection%20on%20dark%20background%20product%20photography%20studio%20lighting&width=400&height=500&seq=genre11&orientation=portrait',
  },
  {
    name: 'スマホ・タブレット',
    desc: 'iPhone・iPad・Android',
    tag: '即日対応',
    alt: 'スマホ・タブレット（iPhone・iPad・Android）買取 — 天神屋 即日対応',
    title: 'スマホ・タブレット買取 | iPhone・iPad・Androidを即日査定',
    img: 'https://readdy.ai/api/search-image?query=premium%20smartphones%20tablets%20iPhone%20iPad%20Samsung%20Android%20devices%20on%20clean%20dark%20background%20professional%20product%20photography%20minimal%20style&width=400&height=500&seq=genre12&orientation=portrait',
  },
];

function GenreCard({ genre, index }: { genre: typeof genres[0]; index: number }) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`relative overflow-hidden rounded-xl cursor-pointer group transition-all duration-700 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
      style={{ transitionDelay: `${(index % 4) * 80}ms` }}
    >
      <div className="aspect-[3/4] relative overflow-hidden rounded-xl">
        <img
          src={genre.img}
          alt={genre.alt}
          title={genre.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

        {/* Tag */}
        <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-amber-500 text-white text-xs font-semibold whitespace-nowrap">
          {genre.tag}
        </div>

        {/* Text */}
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <div className="text-white font-bold text-lg leading-tight">{genre.name}</div>
          <div className="text-white/70 text-xs mt-1">{genre.desc}</div>
        </div>
      </div>
    </div>
  );
}

export default function Genres() {
  const ref = useRef<HTMLDivElement>(null);
  const [titleVisible, setTitleVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setTitleVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="genres" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div ref={ref} className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
          <div className={`transition-all duration-700 ${titleVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}>
            <span className="text-amber-600 text-sm font-semibold tracking-widest uppercase mb-2 block">GENRES</span>
            <h2 className="text-4xl md:text-5xl font-black text-stone-900 leading-tight" style={{ fontFamily: '\'Noto Serif JP\', serif' }}>
              福岡・九州の出張買取<br />取扱ジャンル
            </h2>
          </div>
          <p className={`text-stone-500 text-base md:text-right max-w-xs leading-relaxed transition-all duration-700 delay-200 ${titleVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'}`}>
            九州全域12カテゴリーの幅広い買取実績。<br />
            不用品はお気軽にご相談ください。
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {genres.map((genre, i) => (
            <GenreCard key={genre.name} genre={genre} index={i} />
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <p className="text-stone-500 text-sm">
            上記以外のお品物もお気軽にご相談ください。
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="text-amber-600 font-semibold ml-2 hover:underline cursor-pointer whitespace-nowrap"
            >
              お問い合わせはこちら →
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
